/** Communications → Templates. */
import React, { useState } from 'react';
import { toast } from 'sonner';
import api from '../../lib/api';
import { EmailEditor } from './EmailEditor';

const inp = 'h-9 w-full rounded-md border px-3 text-sm';
export const errMsg = (e) => (typeof e.message === 'string' ? e.message : 'Something went wrong');

export function TemplateEditor({ initial, isMsc, onSaved, onCancel }) {
  const [t, setT] = useState(initial || { name: '', subject: '', category: 'General', format: 'RICH', visibility: 'PRIVATE', body: '' });
  const save = async () => { try { onSaved(await api.request('/communications/templates', { method: 'PUT', body: JSON.stringify(t) })); toast.success('Template saved'); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div className="space-y-3 rounded-xl border bg-card p-5" data-testid="template-editor">
      <div className="grid gap-2 sm:grid-cols-2">
        <input className={inp} placeholder="Template name" value={t.name} onChange={(e) => setT({ ...t, name: e.target.value })} data-testid="template-name" />
        <input className={inp} placeholder="Category (e.g. Dual Pricing)" value={t.category} onChange={(e) => setT({ ...t, category: e.target.value })} data-testid="template-category" />
        <input className={`${inp} sm:col-span-2`} placeholder="Subject — merge fields like {{business_name}} work here" value={t.subject} onChange={(e) => setT({ ...t, subject: e.target.value })} data-testid="template-subject" />
        <select className={inp} value={t.format} onChange={(e) => setT({ ...t, format: e.target.value })} data-testid="template-format"><option value="RICH">Rich email</option><option value="PLAIN">Plain text</option></select>
        <select className={inp} value={t.visibility} onChange={(e) => setT({ ...t, visibility: e.target.value })} data-testid="template-visibility">
          <option value="PRIVATE">Private</option><option value="TEAM">My team</option>{isMsc && <option value="MSC_SHARED">MSC shared (all Agents)</option>}
        </select>
      </div>
      <EmailEditor format={t.format} value={t.body} onChange={(body) => setT((x) => ({ ...x, body }))} testid="template-body" />
      <div className="flex gap-2">
        <button type="button" className="h-9 rounded-full bg-primary px-5 text-sm text-primary-foreground" onClick={save} data-testid="template-save-btn">Save template</button>
        <button type="button" className="h-9 rounded-full border px-5 text-sm" onClick={onCancel} data-testid="template-cancel-btn">Cancel</button>
      </div>
    </div>
  );
}

export function TemplateList({ templates, onEdit }) {
  return (
    <div className="divide-y rounded-xl border bg-card" data-testid="template-list">
      {!templates.length && <p className="p-5 text-sm text-muted-foreground">No templates yet.</p>}
      {templates.map((t) => (
        <button type="button" key={t.template_id} onClick={() => onEdit(t)} className="flex w-full items-center justify-between px-5 py-3 text-left text-sm hover:bg-muted/40" data-testid={`template-row-${t.template_id}`}>
          <span><b>{t.name}</b> <span className="text-muted-foreground">· {t.subject}</span></span>
          <span className="text-xs text-muted-foreground">{t.category} · {t.format === 'PLAIN' ? 'Plain' : 'Rich'} · {t.visibility.replace('_', ' ')}</span>
        </button>
      ))}
    </div>
  );
}
